/* /pages/search-results controller — renders engine matches as theme product cards. */
(function () {
  'use strict';

  var STAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 0L8.653 5.08623H14L9.674 8.23029L11.3271 13.3155L7 10.1714L2.67403 13.3155L4.32597 8.22924L0 5.08518H5.347L7 0Z" fill="#FFB800"/></svg>';
  var EYE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.42716 6C1.50002 6.12591 1.59662 6.28637 1.71628 6.47165C2.02362 6.94754 2.47878 7.5804 3.06969 8.21071C4.26368 9.48429 5.933 10.6667 8 10.6667C10.067 10.6667 11.7363 9.48429 12.9303 8.21071C13.5212 7.5804 13.9764 6.94754 14.2837 6.47165C14.4034 6.28637 14.5 6.12591 14.5728 6C14.5 5.87409 14.4034 5.71363 14.2837 5.52835C13.9764 5.05246 13.5212 4.4196 12.9303 3.78929C11.7363 2.51571 10.067 1.33333 8 1.33333C5.933 1.33333 4.26368 2.51571 3.06969 3.78929C2.47878 4.4196 2.02362 5.05246 1.71628 5.52835C1.59662 5.71363 1.50002 5.87409 1.42716 6ZM15.3333 6C15.9296 5.70186 15.9294 5.70139 15.9294 5.70139L15.9283 5.69925L15.926 5.69469L15.9184 5.67988C15.9121 5.66752 15.9031 5.65021 15.8915 5.62829C15.8683 5.58447 15.8347 5.52215 15.7907 5.44399C15.7028 5.28776 15.5734 5.06768 15.4038 4.80498C15.0653 4.28088 14.5621 3.5804 13.903 2.87737C12.597 1.48429 10.5997 0 8 0C5.40033 0 3.40299 1.48429 2.09698 2.87737C1.43789 3.5804 0.93471 4.28088 0.596224 4.80498C0.426567 5.06768 0.297195 5.28776 0.209314 5.44399C0.165349 5.52215 0.131693 5.58447 0.108502 5.62829C0.0969045 5.65021 0.0879168 5.66752 0.0815586 5.67988L0.0739933 5.69469L0.0716926 5.69925L0.0709134 5.7008C0.0709134 5.7008 0.0703819 5.70186 0.666667 6L0.0703819 5.70186C-0.0234606 5.88954 -0.0234606 6.11046 0.0703819 6.29814L0.666667 6C0.0703819 6.29814 0.0703819 6.29814 0.0703819 6.29814L0.0716926 6.30075L0.0739933 6.30531L0.0815586 6.32012C0.0879168 6.33248 0.0969045 6.34979 0.108502 6.37171C0.131693 6.41553 0.165349 6.47785 0.209314 6.55601C0.297195 6.71224 0.426567 6.93232 0.596224 7.19502C0.93471 7.71913 1.43789 8.4196 2.09698 9.12263C3.40299 10.5157 5.40033 12 8 12C10.5997 12 12.597 10.5157 13.903 9.12263C14.5621 8.4196 15.0653 7.71913 15.4038 7.19502C15.5734 6.93232 15.7028 6.71224 15.7907 6.55601C15.8347 6.47785 15.8683 6.41553 15.8915 6.37171C15.9031 6.34979 15.9121 6.33248 15.9184 6.32012L15.926 6.30531L15.9283 6.30075L15.9291 6.2992C15.9291 6.2992 15.9296 6.29814 15.3333 6ZM15.3333 6L15.9296 6.29814C16.0235 6.11046 16.0232 5.88907 15.9294 5.70139L15.3333 6Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.33333 6C5.33333 4.52724 6.52724 3.33333 8 3.33333C9.47276 3.33333 10.6667 4.52724 10.6667 6C10.6667 7.47276 9.47276 8.66667 8 8.66667C6.52724 8.66667 5.33333 7.47276 5.33333 6ZM8 4.66667C7.26362 4.66667 6.66667 5.26362 6.66667 6C6.66667 6.73638 7.26362 7.33333 8 7.33333C8.73638 7.33333 9.33333 6.73638 9.33333 6C9.33333 5.26362 8.73638 4.66667 8 4.66667Z" fill="white"/></svg>';
  var BELL_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.00016 1.75065C5.06717 1.75065 3.50016 3.31765 3.50016 5.25065V8.16732C3.50016 8.59232 3.38654 8.99078 3.188 9.33398H10.8123C10.6138 8.99078 10.5002 8.59232 10.5002 8.16732V5.25065C10.5002 3.31765 8.93316 1.75065 7.00016 1.75065ZM12.8335 9.33398C12.1892 9.33398 11.6668 8.81165 11.6668 8.16732V5.25065C11.6668 2.67332 9.57749 0.583984 7.00016 0.583984C4.42283 0.583984 2.3335 2.67332 2.3335 5.25065V8.16732C2.3335 8.81165 1.81116 9.33398 1.16683 9.33398C0.844663 9.33398 0.583496 9.59515 0.583496 9.91732C0.583496 10.2395 0.844663 10.5007 1.16683 10.5007H12.8335V9.33398ZM5.48552 11.9595C5.58964 11.7787 5.78238 11.6673 5.991 11.6673H8.00933C8.21795 11.6673 8.41069 11.7787 8.51481 11.9595C8.61893 12.1403 8.61859 12.3629 8.51391 12.5434C8.20084 13.0831 7.6241 13.4152 7.00016 13.4152C6.37623 13.4152 5.79949 13.0831 5.48641 12.5434C5.38173 12.3629 5.38139 12.1403 5.48552 11.9595Z" fill="#424242"/></svg>';

  // same markup as snippets/product-card-grid.liquid
  function cardHtml(p) {
    var core = window.RevamSearchCore;
    var esc = core.escapeHtml;
    var url = '/products/' + encodeURIComponent(p.h);
    var onSale = p.cap && p.cap !== '' && Number(p.cap) > Number(p.p);
    var discountPct = 0;
    if (onSale) {
      discountPct = Math.round((Number(p.cap) - Number(p.p)) * 100 / Number(p.cap));
    }

    // product-price.liquid markup
    var priceHtml = '';
    if (onSale) {
      priceHtml += '<s class="product-price__price product-price__compare">' + esc(core.money(p.cap)) + '</s>';
      priceHtml += '<span class="product-price__price product-price__sale">' + esc(core.money(p.p)) + '<span class="product-price__sale-label">Sale</span></span>';
    } else {
      priceHtml += '<span class="product-price__price">' + esc(core.money(p.p)) + '</span>';
    }
    if (!p.av) priceHtml += '<span class="product-price__sold-out">Email me when available</span>';

    var html = '';
    html += '<div class="collection-one-line grid__item grid__item--collection-template small--one-half medium-up--one-quarter">';
    html += '<div class="grid-view-item' + (!p.av ? ' product-price--sold-out grid-view-item--sold-out' : '') + '">';
    html += '<div class="collection_cover">';
    html += '<div class="collection_left snip1205">';
    // rating metafield isn't available client-side; the snippet hardcodes 4.9
    // html += '<div class="custom-collection-product__rating">';
    // html += '<div class="custom-collection-product__star">' + STAR_SVG + '</div>';
    // html += '<span class="custom-collection__rating-value">4.9</span>';
    // html += '</div>';
    html += '<a class="product-card__image-wrapper" href="' + url + '">';
    if (p.img) {
      html += '<img class="grid-view-item__image" src="' + esc(core.thumb(p.img, 500)) + '" alt="' + esc(p.t) + '" loading="lazy">';
    }
    if (discountPct > 0) {
      html += '<div class="product-card__discount-badge"><span class="product-card__discount-text">' + discountPct + '% OFF</span></div>';
    }
    html += '</a>';
    // handled by the delegated custom-atc-card-btn listener
    html += '<button type="button" class="custom-atc-hover-btn" data-custom-atc';
    html += ' data-product-handle="' + esc(p.h) + '"';
    html += ' data-variant-count="' + (p.vc || 0) + '"';
    html += ' data-first-variant-id="' + (p.vid || '') + '"';
    if (!p.av) html += ' disabled aria-disabled="true"';
    html += '>';
    if (p.av) {
      html += '<span>Add to cart</span> <span>' + esc(core.money(p.p)) + '</span>';
    } else {
      html += 'Sold out';
    }
    html += '</button>';
    // plain product link, as in the snippet
    html += '<div class="quick_view quick-view-button"><a class="quick_btn quick-view" href="' + url + '">' + EYE_SVG + '<span>view Product</span></a></div>';
    // freegift app hooks, matched by name attribute
    html += '<div name="secomapp-fg-image-' + p.pid + '" style="display: none;"></div>';
    html += '<div class="sca-fg-cat-list" style="display:none;" name="secomapp-fg-data-' + p.pid + '" prod-show=\'list\'></div>';
    html += '</div>'; // collection_left
    html += '<div class="collection_right">';
    html += '<a class="grid-view-item__link" href="' + url + '"><div class="h4 grid-view-item__title">' + esc(p.t) + '</div></a>';
    html += '<a class="price_rev" href="' + url + '"><div class="grid-view-item__meta">' + priceHtml + '</div></a>';
    if (p.sku0) {
      html += '<a class="sku_title" href="' + url + '"><span> SKU : ' + esc(p.sku0) + ' </span></a>';
    }
    if (!p.av) {
      html += '<div class="all_new">';
      html += '<div class="out_of_stock"><span class="oos">Out of Stock</span></div>';
      html += '<a href="#" class="BIS_trigger" data-product-data="' + esc(JSON.stringify({ id: p.pid, title: p.t, handle: p.h, available: false })) + '">' + BELL_SVG + ' Notify me</a>';
      html += '</div>';
    }
    html += '</div>'; // collection_right
    html += '</div>'; // collection_cover
    html += '</div>'; // grid-view-item
    html += '</div>'; // collection-one-line
    return html;
  }

  function init() {
    var root = document.querySelector('[data-revam-search-results]');
    if (!root || !window.RevamSearchCore) return;
    var core = window.RevamSearchCore;

    var headingEl = root.querySelector('[data-revam-sr-heading]');
    var messageEl = root.querySelector('[data-revam-sr-message]');
    var messageHr = root.querySelector('[data-revam-sr-noresults-hr]');
    var divider = document.querySelector('[data-revam-sr-divider]');
    var controller = document.getElementById('SearchPageController');
    var grid = document.querySelector('[data-revam-sr-grid]');
    var searchInput = document.getElementById('SearchInput');

    var q = (new URLSearchParams(window.location.search).get('q') || '').trim();
    if (searchInput && q) searchInput.value = q;

    var searchTitle = headingEl ? headingEl.textContent.trim() : 'Search our site';

    function showMessage(msg) {
      if (messageEl) { messageEl.hidden = false; messageEl.textContent = msg; }
      if (messageHr) messageHr.hidden = false;
      if (divider) divider.hidden = true;
      if (controller) controller.hidden = true;
    }

    if (!q) {
      // bare visit: heading only
      if (controller) controller.hidden = true;
      if (divider) divider.hidden = true;
      return;
    }

    if (q.length < core.MIN_QUERY_LENGTH) {
      showMessage('Enter at least ' + core.MIN_QUERY_LENGTH + ' characters to search.');
      return;
    }

    core.loadIndex().then(function () {
      var results = core.searchProducts(q);
      if (!results.length) {
        showMessage('Your search for \u201C' + q + '\u201D did not yield any results.');
        return;
      }
      if (headingEl) {
        headingEl.textContent = results.length + (results.length === 1 ? ' result for \u201C' : ' results for \u201C') + q + '\u201D';
      }
      if (messageEl) messageEl.hidden = true;
      if (messageHr) messageHr.hidden = true;
      if (divider) divider.hidden = false;
      if (controller) controller.hidden = false;
      var html = '';
      for (var i = 0; i < results.length; i++) html += cardHtml(results[i]);
      grid.innerHTML = html;
    }).catch(function (err) {
      showMessage('Search is temporarily unavailable. Please try again.');
      if (window.console) console.warn('[revam-search-results] index load failed', err);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
